import { useLocalization } from "../../hooks/useLocalization";
import { UpcomingMatch } from "../../types/types";
import { HomeMatchSection } from "./HomeMatchSection";

interface LatestGamesProps {
  upcomingMatches: UpcomingMatch[] | undefined;
}

export const LatestGames = ({ upcomingMatches }: LatestGamesProps) => {
  const { strings } = useLocalization();

  return (
    <HomeMatchSection
      title={strings.LATEST_GAMES.TITLE}
      matches={upcomingMatches}
      mode="upcoming"
      scheduleLinkLabel={strings.SCHEDULE.VIEW_FULL}
      emptyContent={
        <div className="schedule-empty-card">
          <p className="schedule-empty-title">{strings.NEWS.NO_UPCOMING_MATCHES}</p>
          <p className="schedule-empty-hint">{strings.NEWS.SCHEDULE_EMPTY_HINT}</p>
        </div>
      }
    />
  );
};
